// Excel експортът на „Гости" — редовете както са на екрана.

import type { TFunction } from "i18next";

import { parseDecimal } from "../../../../components/dataTable";
import { exportToExcel, type ExcelColumn } from "../../../../utils/excelExport";
import type { ReservationGuestRow } from "../../../../api/reportsReservations";
import { formatMomentWithDate, noShowRate } from "./reservationReportFormat";

type Options = {
  rows: readonly ReservationGuestRow[];
  t: TFunction;
};

export const exportGuests = ({ rows, t }: Options) => {
  const columns: ExcelColumn<ReservationGuestRow>[] = [
    { header: t("reportsPage.rvColumnName"), value: (row) => row.guest_name, width: 24 },
    { header: t("reportsPage.rvColumnPhone"), value: (row) => row.phone, width: 16 },
    { header: t("reportsPage.rvKpiReservations"), value: (row) => row.reservations, width: 12 },
    { header: t("reportsPage.rvStatus_upcoming"), value: (row) => row.upcoming, width: 12 },
    { header: t("reportsPage.rvStatus_seated"), value: (row) => row.seated, width: 12 },
    { header: t("reportsPage.rvStatus_completed"), value: (row) => row.completed, width: 12 },
    { header: t("reportsPage.rvStatus_cancelled"), value: (row) => row.cancelled, width: 12 },
    { header: t("reportsPage.rvStatus_expired"), value: (row) => row.expired, width: 12 },
    {
      header: t("reportsPage.rvColumnNoShowRate"),
      value: (row) => {
        const rate = noShowRate(row);
        return rate === null ? null : Math.round(rate);
      },
      width: 12,
    },
    { header: t("reportsPage.rvKpiGuests"), value: (row) => row.guests, width: 10 },
    { header: t("reportsPage.rvKpiRevenue"), value: (row) => parseDecimal(row.revenue), width: 12 },
    { header: t("reportsPage.rvColumnLastVisit"), value: (row) => formatMomentWithDate(row.last_visit_at), width: 18 },
    { header: t("reportsPage.rvColumnLastReservation"), value: (row) => formatMomentWithDate(row.last_reservation_at), width: 18 },
    { header: t("reportsPage.rvColumnFirstReservation"), value: (row) => formatMomentWithDate(row.first_reservation_at), width: 18 },
  ];

  exportToExcel<ReservationGuestRow>({
    filename: t("reportsPage.rvGuests"),
    sheetName: t("reportsPage.rvGuests"),
    columns,
    rows: [...rows],
  });
};
